import { ctrlRegistry } from "../common/components/CustomCtrl";
import { doRegistration as doCommonRegistration } from "../common/components/customCtrlRegistrations";

export const doRegistration = () => {
    ctrlRegistry.clear();
    doCommonRegistration();
    ctrlRegistry.register('jobid',
        () => import('./JobIDLabel'),
        { supportsEditor: false }
    );
    ctrlRegistry.register('joblist',
        () => import('./JobTable'),
        { supportsEditor: false }
    );
    ctrlRegistry.register('epcrAcuity', 
        () => import('./epcr/EpcrAcuityDropdown'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('epcrDisposition',
        () => import('./epcr/EpcrDispositionDropdown'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('listEntry',
        () => import('./ListReferenceInput')
    )
    ctrlRegistry.register('referenceDocumentLink',
        () => import('./ReferenceDocLink')
    )
    ctrlRegistry.register('pivotTable',
        () => import('./PivotTable')
    )
    ctrlRegistry.register('type',
        () => import('./TypeDropdown'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('level',
        () => import('./LevelDropdown'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('site',
        () => import('./SiteDropdown'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('problem',
        () => import('./ProblemInput'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('priority', 
        () => import('./PriorityDropdown'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('event', 
        () => import('./EventDropdown'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('contactList',
        () => import('./ContactListDropdown'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('zone',
        () => import('./ZoneDropdown'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('access',
        () => import('./AccessDropdown'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('medication',
        () => import('./epcr/medication/MedicationInput'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('medicationRoute',
        () => import('./epcr/medication/RouteInput'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('medicationDose',
        () => import('./epcr/medication/DoseInput'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('medicationNotes',
        () => import('./epcr/medication/MedicationNotesInput'),
        { supportsEditor: false }
    )
}